import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // <-- Add this
import { applyNewApmcApplication, applyNewFormApmcApplication } from '../../auth/services/privateapicalling';
import { useSelector } from 'react-redux';
import { languageMappingForms } from '../LandDistrict/Json/AllData';
import { toast,ToastContainer } from "react-toastify";
const SchemeSelectorLand: React.FC = () => {
  const token = useSelector((state:any)=>state.auth.token);

  const [selectedForm, setSelectedForm] = useState<any | null>(null);
  const navigate = useNavigate(); // <-- Add this

 const [forms,setForms] = useState<any[]>();

  const handleFormSelect = (value:any) => {
    setSelectedForm(value);
  };
  const fetchForms = async () => {
    try {
      const response = await applyNewFormApmcApplication(token);
    
      if (response?.success) {
        setForms(response?.data);
      }
    } catch (error) {
     
    }
  };
  const handleProceed = async() => {
    try {
          const res=await applyNewApmcApplication(selectedForm?.id,token,"form")
      
      
    if (res?.success) {
      navigate('/allForms',{
        state: {
        type:  selectedForm?.id,
        applicationId: res?.data?.applicationId,
        couchId: res?.data?.applicationDataId
          
      }} );
     
    } 
    else {
    
      toast.error(res?.message || "already applied for this scheme");
    }
  } catch (error) {
    
      toast.error("Failed to apply for the selected form. Please try again.");
    }
    // Add more navigation logic for other forms if needed
  };
useEffect(() => {
    fetchForms();
  }
, []);
const chunkArray = (arr: any[], size: number) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};
const getGujaratiLabel = (english: string): string => {
  const match = languageMappingForms.find(item => item.value === english);
  return match?.label || english; // fallback to English if not found
};
  return (
    <div className='page-wrapper'>
      <div className="container py-3 border bg-white my-4">
        {/* <h4>Forms</h4>
        <p className="text-muted mb-4">
          Choose the appropriate scheme from the list given below to proceed with your application.
        </p> */}

        <div className="row g-4">
          {/* Left Column: Form Selection */}
          <div className="col-md-8">
            <div className="card p-3 border">
              <h5>Select a Form</h5>
              <p className="text-muted mb-3">Choose the form that best fits your requirements</p>
              <div className="row d-flex flex-column flex-wrap flex-md-row gap-3 flex">
                {forms?.map((form) => (
                  <button
                key={form?.id}
                className={`btn btn-light border d-flex align-items-center justify-content-between flex-fill ${
                  selectedForm?.id === form?.id ? 'border-info bg-info-subtle' : ''
                }`}
                style={{ width: '40%', textAlign: 'start' }}
                onClick={() => handleFormSelect(form)}
              >
                {/* Left Side Content (aligned left) */}
                <div className="d-flex align-items-center gap-2 text-start">
                  <i className="feather feather-feather fs-2 border border-white bg-info rounded"></i>
                                   <span>{getGujaratiLabel(form?.name)}<br /><small className="text-muted">{form?.name}</small></span>
 
                </div>

                {/* Right Side Tick Icon */}
                {selectedForm?.id === form?.id && (
                  <span className="text-primary">
                    <i className="bi bi-check-circle-fill"></i>
                  </span>
                )}
              </button>

                ))}
              </div>
            </div>

            <div className="mt-4 ">
              <button
                className="btn btn-info"
                disabled={!selectedForm}
                onClick={handleProceed} // <-- Add this
              >
                Proceed to Fill Form
              </button>
            </div>
          </div>

          {/* Right Column: Guidelines */}
          <div className="col-md-4">
            <div className="card p-3 border text-center">
              <h6 className="text-secondary mb-2 d-flex align-items-center justify-content-center gap-1">
                Form Guidelines 
              </h6>
              <p className="text-muted small">Required to follow</p>
              <div className="text-primary">
                <i className='feather feather-file-text fs-2 border rounded-circle p-1 text-info border-info'></i>
                <p className="text-muted mt-2 mb-0 small">
                  Choose a form from the given list to see available purposes and proceed with your application.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={3000} position='top-right'/>    </div>
  );
};

export default SchemeSelectorLand;